import Minze, { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'

export interface LvcFilterChip {
  value?: string
  selected?: boolean
  onClick?: string
}

export class LvcFilterChip extends MinzeElement {
  reactive: Reactive = [['checked', false]]
  attrs: Attrs = ['on-click', 'value', 'selected']

  static observedAttributes = ['selected', 'value']

  onAttributeChange = (name: string, oldValue: string, newValue: string) => {
    if (name === 'selected') {
      this.checked = newValue === 'true'
    }
  }

  handleClick(e: Event) {
    if (this.onClick) {
      Callback.call(this.onClick, { value: this.value })
    } else {
      Minze.cast('lvc:category-chip', { value: this.value })
    }
  }

  html = () => `
    <button class="chip ${this.responsive ? 'responsive' : ''}" type="${this.type}">
      <div class="checkbox ${this.checked ? 'selected' : ''}">
        ${this.checked ? `<lvc-check-icon data-size="14px"></lvc-check-icon>` : ''}
      </div>
      <slot></slot>
    </button>
  `

  css = () => {
    return `
      .chip {
        font-family: ${Font.family};
        font-size: 14px;
        color: #1E007D;
        font-weight: ${Font.weight.medium};
        border: none;
        border-radius: 99px;
        padding: 0;
        cursor: pointer;
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s ease-in-out;
        backface-visibility: hidden;
        background: transparent;
      }
      
      .checkbox {
        width: 20px;
        height: 20px;
        border: 1px solid #1E007D;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .checkbox.selected {
        background: var(--CIEL, #BFF0FF);
        border-color: var(--CIEL, #BFF0FF);
      }
      
      .checkbox.selected >lvc-check-icon {
        height: 14px;
      }
    `
  }

  eventListeners: EventListeners = [[this, 'click', this.handleClick]]
}
